module.exports = __webpack_public_path__ + "img/adviser.20444489.png";